import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link, useNavigate, useLocation } from "react-router-dom";
import {Utils} from '../../Utils.js';
import './AppFooterMenu.css';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { withAppContext, ModalsContext } from '../../contexts/AppContext';

const HideOnKeyboardOpen = (props)=>{

  const isKeyboardOpen = useDetectKeyboardOpen(250);
  const children = (props.children) ? props.children : null;

  return <div style={{visibility:((isKeyboardOpen) ? 'hidden' : 'visible')}}>{children}</div>
}


class AppFooterMenu extends React.Component {

  static contextType = ModalsContext;

  constructor(props){
      
    super(props);

    this.state = {
      menu_items : {
        home:{path:'',ref_obj_name:null,active:true},
        favorites:{path:'favorites',ref_obj_name:null,active:false},
        shops:{path:'shops',ref_obj_name:'ShopsRef',active:false},
        menu_profile:{path:'sign-in',ref_obj_name:'',active:false},
        products_menu:{path:null,ref_obj_name:'ProductsMenuRef',active:false},
      },
      shopping_cart:{}
    };

    this.appRef = props.appContext.appRef;

    
  }

  set_app_data(shopping_cart)
  {
    const menu_items = this.state.menu_items;

    if(this.appRef.current?.state?.is_signed)
    {
      menu_items.menu_profile.ref_obj_name = 'ProfileMenuRef';
      menu_items.menu_profile.path = null;
    }
    else 
    {
      menu_items.menu_profile.ref_obj_name = null;
      menu_items.menu_profile.path = 'sign-in';
    }

    this.setState({shopping_cart:shopping_cart, menu_items: menu_items});
  }

  set_is_signed()
  {
    const menu_items = this.state.menu_items;
    
    if(this.appRef.current?.state?.is_signed)
    {
      menu_items.menu_profile.ref_obj_name = 'ProfileMenuRef';
      menu_items.menu_profile.path = null;
      menu_items.menu_profile.active=false;
    }
    else 
    {
      menu_items.menu_profile.ref_obj_name = null;
      menu_items.menu_profile.path = 'sign_in';
    }
    this.setState({menu_items: menu_items});
  }

  componentDidMount()
  {
    if(this.appRef.current?.state?.shopping_cart)
    {
      this.set_app_data(this.appRef.current.state.shopping_cart);
    }
  }

  set_item_inactive_by_name(item_name)
  {
    if(this.state.menu_items[item_name]){
      this.state.menu_items[item_name].active = false;
      this.setState(this.state);
    }
  }

  deactivate_all_menu_items() {
      for (const [key, value] of Object.entries(this.state.menu_items)) {
        this.state.menu_items[key].active=false;
      }
      this.setState(this.state);
  }

  hide_all_menu_item() {
    const modalsContext = this.context;
    Object.keys(modalsContext).forEach((key,index)=>{
      if(modalsContext[key]?.current){
        if(typeof modalsContext[key].current.hide !== 'undefined'){
          modalsContext[key].current.hide();
        }
      }
    });
  }

  menu_item_is_active(item_name){

    if(Object.keys(this.state.menu_items[item_name]).length>0)
    {
      if(!this.state.menu_items[item_name].ref_obj_name) //path alapján kell eldönteni hogy aktív-e az oldal
      {
        const path = Utils.get_path_from_url();

        if(path===this.state.menu_items[item_name].path)
        {
          let has_active_modal = false;

          for (const [key, value] of Object.entries(this.state.menu_items)) {
            if(this.state.menu_items[key].ref_obj_name && this.state.menu_items[key].active===true){
              has_active_modal = true;
            }
          }

          if(!has_active_modal)
          {
            this.state.menu_items[item_name].active=true;
          }
        }
        else
        {
          this.state.menu_items[item_name].active=false;
        }
      }

      return this.state.menu_items[item_name].active;
    }
    else
    {
      return false;
    }

  }

  handle_item_click(item_name, e = null){
    const modalsContext = this.context;

    if (e && e.stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }

    if(Object.keys(this.state.menu_items[item_name]).length>0)
    {
      if(!this.state.menu_items[item_name].ref_obj_name) //path alapján kell eldönteni hogy aktív-e az oldal
      {
        Object.keys(modalsContext).forEach((key,index)=>{
          if (typeof modalsContext[key]?.current?.hide !== 'undefined')
          {
            modalsContext[key].current.hide();
          } 
        });

        for (const [key, value] of Object.entries(this.state.menu_items)) {
          this.state.menu_items[key].active=false;
        }
      }
      else //modal
      {
        const currentRefName = this.state.menu_items[item_name].ref_obj_name;

        if (this.props.location?.pathname?.includes('favorites')) {
          this.props.navigate('/');
        }

        Object.keys(modalsContext).forEach((key,index)=>{
          
          if (key !== currentRefName)
          {
            if (typeof modalsContext[key]?.current?.hide !== 'undefined')
            {
              modalsContext[key].current.hide();
            }
          }
        });

        const item_ref_name = this.state.menu_items[item_name].ref_obj_name;
        const modal_ref = modalsContext[item_ref_name];


        if(this.state.menu_items[item_name].active===true)
        {
          this.state.menu_items[item_name].active=false;
          if (modal_ref && modal_ref.current) {
             modal_ref.current.hide();
          }
        }
        else
        {
          for (const [key, value] of Object.entries(this.state.menu_items)) {
            this.state.menu_items[key].active=false;
          }

          modal_ref.current.show();
          this.state.menu_items[item_name].active = true;
        }
      }

      this.setState(this.state);
    }

  }

  render() {

    return (
      <HideOnKeyboardOpen>
        <footer>
          <div className={"menu" + (this.menu_item_is_active('home') ? " active" : "")}>
            <Link data-type="home" to="/" onClick={()=>this.handle_item_click('home')}>
              <div className="icon"><ReactSVG src={`/assets/images/home.svg`} /></div>
              <div className="title">{i18n.t('footerMenuHome')}</div>
            </Link>
          </div>

          <div className={"menu" + (this.menu_item_is_active('products_menu') ? " active" : "")}>
            <div onClick={() => this.handle_item_click('products_menu') }>
              <div className="icon"><ReactSVG src={`/assets/images/categories.svg`} /></div>
              <div className="title">{i18n.t('footerMenuProducts')}</div>
            </div>
          </div>

          <div className={"menu" + (this.menu_item_is_active('shops') ? " active" : "")}> 
            {/* to={"/shops"}*/}
            <div onClick={()=>this.handle_item_click('shops')}>
              <div className="icon"><ReactSVG src={`/assets/images/shops.svg`} /></div>
              <div className="title">{i18n.t('footerMenuShops')}</div>
            </div>
          </div>

          <div className={"menu" + (this.menu_item_is_active('favorites') ? " active" : "")}> 
            <Link to={"/favorites"} data-type="in_app" onClick={() => this.handle_item_click('home')}>
              <div className="icon">
                <ReactSVG src={`/assets/images/favorites_off.svg`} />
                {this.appRef.current.state.favorites.length > 0 ? <div className="fav_count_badge">{this.appRef.current.state.favorites.length}</div> : ''}
              </div>
              <div className="title">{i18n.t('footerFavorites')}</div>
            </Link>
          </div>

          <div className={"menu" + (this.menu_item_is_active('menu_profile') ? " active" : "")}>
            {
              (this.state.menu_items.menu_profile.ref_obj_name) ?
              <div onClick={(e) => this.handle_item_click('menu_profile', e) }>
                <div className="icon"><ReactSVG src={`/assets/images/profile.svg`} /></div>
                <div className="title">{i18n.t('footerMenuProfile')}</div>
              </div>
              :
              <Link to="/sign-in" data-type="in_app">
                <div className="icon"><ReactSVG src={`/assets/images/profile.svg`} /></div>
                <div className="title">{i18n.t('footerMenuProfile')}</div>
              </Link>
            }
          </div>

        </footer>
      </HideOnKeyboardOpen>
    );
  }
  
};

const AppFooterMenuWrapper = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  return <AppFooterMenu {...props} navigate={navigate} location={location} ref={ref} />;
});

export default withAppContext(AppFooterMenuWrapper);
